import { withStyles } from '@material-ui/core';
import Account from './Account';
import styles from './styles';

export default withStyles(styles)(Account);
